import { useDynamicPrice } from "@jetshop/core/hooks/useDynamicPrice";
import { useProductVariants } from "@jetshop/core/hooks/useProductVariants";
import { useVariantFromUrl } from "@jetshop/core/hooks/useProductVariants/useVariantFromUrl";
import { useContext, useEffect } from "react";
import { isJetshopProductNew } from "../Util/Helpers";

const UseFormatProductPage = (product) => {
   product = product ? { ...product } : null

   const sortVariantsOnArticleNumber = variantData => {
      if (variantData && variantData.values.length > 1) {
         let sortedVariants = {
            __typename: variantData.__typename,
            options: [
               {
                  __typename: variantData.options[0].__typename,
                  name: variantData.options[0].name,
                  values: [],
               },
            ],
            values: [...variantData.values],
         }

         // SORT VALUES
         sortedVariants.values.sort((a, b) => {
            if (a.articleNumber < b.articleNumber) {
               return -1
            }
            if (a.articleNumber > b.articleNumber) {
               return 1
            }
            return 0
         })

         // EXTRACT CORRECT OPTION ORDER
         sortedVariants.values.forEach((value, index) => {
            sortedVariants.options[0].values.push(value.values[0])
         })

         return sortedVariants
      } else {
         return variantData
      }
   }

   function useSortedVariants(product) {
      if (product) {
         return (product.variants = product
            ? sortVariantsOnArticleNumber(product.variants)
            : {})
      }
   }

   // function changeVariant(newVariant) {
   //    obj.selectedVariant = newVariant;
   // }

   const variants = useSortedVariants(product)
   const initialVariant = useVariantFromUrl()
   const variantHandler = useProductVariants(
      { ...product, variants },
      {
         initialVariant,
         preselectCheapest: false,
      }
   )
   
   const variantExistfromUrl = variantHandler?.selectedVariant ? true : false; 
   let price = useDynamicPrice(product, variantHandler?.selectedVariant)
   price = variantExistfromUrl ? price : null;
   const packageProductPrice = useDynamicPrice(product)

   let formattedProduct = {
      id: product?.id,
      articleNumber: product?.articleNumber,
      images: product?.images,
      url: product?.primaryRoute?.path,
      hasVariants: product?.variants?.values?.length > 1,
      description: product?.description,
      buyable: product?.stockStatus?.buyable,
      customFields: product?.customFields,
      isPackage: product?.isPackage,
   }

   // formattedProduct.variants = variants
   formattedProduct.variantHandler = variantHandler;

   // let variant = variantHandler?.selectedVariant ?? formattedProduct.variants?.values[0];
   // formattedProduct.selectedVariant = { ...variant, images: product?.images, title: formattedProduct?.hasVariants ? product?.name + " " + variant?.values[0] : product?.name, hasVariants: formattedProduct?.hasVariants };
   formattedProduct.variants = [];

   let isPackage = product?.customFields?.find(cf => cf?.key == "paket")?.boolValue || formattedProduct?.isPackage;
   let isNew = isJetshopProductNew(product?.publishedDate);

   if (product?.variants?.values && !formattedProduct?.isPackage) {
      for(let variant of product?.variants?.values ?? []) {
         let formattedVariant = {
            ...variant,
            images: product?.images,
            title: formattedProduct?.hasVariants
               ? product?.name + ' ' + variant?.values[0]
               : product?.name,
            brandName : product?.subName,
            hasVariants: formattedProduct?.hasVariants,
            isPackage,
            mainVariant: product?.articleNumber,
            isNew,
         }
         if (price?.previousPrice?.incVat == price?.price?.incVat) {
            formattedVariant.currentPrice = price?.price?.incVat
            formattedVariant.onSale = false;
         } else {
            formattedVariant.currentPrice = price?.price?.incVat
            formattedVariant.oldPrice = price?.previousPrice?.incVat
            formattedVariant.onSale = true;
         }
         if (price?.previousPrice?.exVat == price?.price?.exVat) {
            formattedVariant.exVatCurrentPrice = price?.price?.exVat
            formattedVariant.onSale = false;
         } else {
            formattedVariant.exVatCurrentPrice = price?.price?.exVat
            formattedVariant.exVatoldPrice = price?.previousPrice?.exVat
            formattedVariant.onSale = true;
         }
         
         formattedVariant.id = product?.id;
         formattedProduct.variants.push(formattedVariant);
      }  
   }

   // Construct variant of product package data
   if (formattedProduct?.isPackage) {
      let constructedPackageVariant = {
         ...product,
         values: [
            product?.name
          ],
         title: product?.name,
         brandName: product?.subName,
         isNew,
      }
      
      if (packageProductPrice?.previousPrice?.incVat == packageProductPrice?.price?.incVat) {
         constructedPackageVariant.currentPrice = packageProductPrice?.price?.incVat
         constructedPackageVariant.onSale = false;
      } else {
         constructedPackageVariant.currentPrice = packageProductPrice?.price?.incVat
         constructedPackageVariant.oldPrice = packageProductPrice?.previousPrice?.incVat
         constructedPackageVariant.onSale = true;
      }
      if (price?.previousPrice?.exVat == packageProductPrice?.price?.exVat) {
         constructedPackageVariant.exVatCurrentPrice = packageProductPrice?.price?.exVat
         constructedPackageVariant.onSale = false;
      } else {
         constructedPackageVariant.exVatCurrentPrice = packageProductPrice?.price?.exVat
         constructedPackageVariant.exVatoldPrice = packageProductPrice?.previousPrice?.exVat
         constructedPackageVariant.onSale = true;
      }

      constructedPackageVariant.id = product?.id;

      formattedProduct.variants.push(constructedPackageVariant)
   }

   const defaultVariantSelectOption = formattedProduct?.variants?.length > 1 ? "" : formattedProduct?.variants[0]?.values[0];

   // Create dummy variant as default if no variant is selected
   let defaultVariant = {
      ...formattedProduct.variants[0],
      values: [defaultVariantSelectOption],
      title: product?.name
   }

   const variantNameFromUrl = initialVariant?.values?.length > 0 ? initialVariant?.values[0] : "";
   formattedProduct.selectedVariant = formattedProduct.variants.find(v => v?.values[0] == variantNameFromUrl) ?? defaultVariant;
   
   formattedProduct.options = product?.variants?.options[0]?.values

   return formattedProduct
}

export default UseFormatProductPage